
import RcDomainMap from "@/domain/common/RcDomainMap.js";

import RepairResult from './RepairResult.js';
import SignatureMap from '../../../user/SignatureMap.js';

export default class RepairResultMap extends RcDomainMap {

  static MODEL_NAME = "VehicleInspectionRepairResultMap";

  constructor(domain, data) {
    super(domain, data, RepairResultMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new RepairResultMap(this.domain, data);
  }

  find() {
    var found = new RepairResultMap(this.domain, {});
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.repairResults().findById(key);
      var item = new RepairResult(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }

    return found;
  }

  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getResult(key);
      values.push(item);
    }
    return values;
  }

  getRepairResult(key) {
    return this.getResult(key);
  }
  
  getResult(key) {
    var value = super.get(key);
    return new RepairResult(this.domain, value);
  }

  hasResults() {
    return this.size() > 0;
  }

  findNew() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var result = this.getResult(key);
      if (result.isNew()) {
        return result;
      }
    }
    return new RepairResult(this.domain, {});
  }

  addResult(repairResult) {
    super.add(repairResult);
    return this;
  }

  signatures() {
    let map = new SignatureMap(this.domain, {});
    let keys = this.keys();
    for (let id in keys) {
      let repairResult = this.getRepairResult(keys[id]);
      map.add(repairResult.signature());
    }
    return map;
  }

  load() {
    let resultsMap = this.find();
    let signatures = resultsMap.signatures().find();
    let keys = resultsMap.keys();
    for (let id in keys) {
      let repairResult = resultsMap.getRepairResult(keys[id]);
      let signature = signatures.getSignature(repairResult.signature().id());
      if (!signature.isNew()) {
        repairResult.withSignature(signature);
      }
    }
    this.addAll(resultsMap);
    return this;
  }
}